//Default authenticated to false, so the user has to login when they visit the admin site
let authenticated = false;

//let subscriptionIsActive = false;

import notify from 'devextreme/ui/notify';

export default {
  authenticated() {
    return authenticated;
  },
  logIn(app, email, password) {

    /*
      Log the user in
      Stored Proc = pr_admin_signIn
    */
    app.$http.post(app.$store.state.appSettings.webServiceUrl + 'ValidateSession',
    {
      Email: email,
      Password: password,
    }
    ).then(function(data){         
        var responseData = JSON.parse(data.body);        
        var message = responseData[0].Message;

        //Authenticate the user as necessary and navigate to the appropriate page, based on the data returned from the ValidateSession method
        if(message == 'Success!'){
          authenticated = true;
          this.$store.commit("setEmail", email);


          if( responseData[0].AccountId != null){
            //Admin user / Restaurant user
            app.$store.commit("setIsAdmin", responseData[0].IsAdmin);

            //Store the AccountId
            this.$store.commit("setCurrentAccountId", responseData[0].AccountId);
            localStorage.dinesafeAccountId = responseData[0].AccountId;

            //Store the AccountName
            this.$store.commit("setCurrentAccountName", responseData[0].AccountName);

            //--- Validate the Subscription - Begin
            
            //https://api.sandbox.paypal.com/v1/billing/subscriptions/{subscriptionId}
            //"subscriptionID": "I-3KWAX1KXX9U6",

            var accessToken = '';
            //var url = 'https://api.sandbox.paypal.com/v1/billing/subscriptions/' + 'I-3KWAX1KXX9U6'; 
            //var url = 'https://api.sandbox.paypal.com/v1/billing/subscriptions/' + responseData[0].SubscriptionId;  //Sandbox
            var url = 'https://api.paypal.com/v1/billing/subscriptions/' + responseData[0].SubscriptionId;  //PROD

            //Get an Access Token.
            //  The code for the first API call to get the AccessToken was mostly generated with Postman
            var myHeaders = new Headers();
            
            //Sandbox
            myHeaders.append("Authorization", "Basic QWFyUkQ2SjM5VW9vbm9nVF8tUTJxV3RkamtjTWUwSnhiRzJvZ1NxNnVvdEtnNlBjQU1nVWFUMk1YV3ZyYW5fZlBRQktlcEVRVEI2VUNpcVU6RUZtME5lamU3cXlkSHM3VFhPSjdCSnd0OE5zQzQxdGNnM2JZd2pwc09rR1dBOTFZS0RycGc0RDUweDFid2hMSnZaT19RTDhaLV8xNUMyVk0="); //Sandbox

            //Prod
            //To generate this line for the Authorization, use the Postman app.  In Postman, pass the app ClientId as the username, and the Secret as the password.
            //More info here: https://developer.paypal.com/docs/api/get-an-access-token-postman/
            myHeaders.append("Authorization", "Basic QVJQVURnbnNBcnV6RC1fb0dVZUdIRW83REdENXFNSWJnWGdFVXZ0VUxBTmh5T2pnSWxpUDNzT1JZcHc1bmdDODgtY2xES3VWTGVCYTFFYWM6RUtYd3NCODFPWTZHRDlzN2owUWZ0N3ljWTRPSUpOUVlDa1k4cVdBUlBQcnc3ZzN1am1VTTdCYlhjOWRmX2JoTjY5dUI4aDBOLTY0aTJQcTg="); //PROD

            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

            //Sandbox
            //myHeaders.append("Cookie", "l7_az=sandbox.slc; X-PP-SILOVER=name%3DLIVE3.WEB.1%26silo_version%3D880%26app%3Dapiplatformproxyserv%26TIME%3D1591643782%26HTTP_X_PP_AZ_LOCATOR%3Dsandbox.slc"); //Sandbox
            
            //PROD
            //myHeaders.append("Cookie", "l7_az=sandbox.slc; X-PP-SILOVER=name%3DLIVE3.WEB.1%26silo_version%3D880%26app%3Dapiplatformproxyserv%26TIME%3D1591643782%26HTTP_X_PP_AZ_LOCATOR%3Dsandbox.slc"); //Prod

            var urlencoded = new URLSearchParams();
            urlencoded.append("grant_type", "client_credentials");

            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: urlencoded,
              redirect: 'follow'
            };

            //Get an AccessToken for PayPal
            //fetch("https://api.sandbox.paypal.com/v1/oauth2/token", requestOptions) //Sandbox
            fetch("https://api.paypal.com/v1/oauth2/token", requestOptions) //Prod
              .then(
                response => response.text()
              )
              .then(
                result => {
                  //Get the AccessToken       
                  accessToken = JSON.parse(result).access_token;

                  //If this is an Admin account, check if the Subscription is active
                  this.$http.get(url, 
                  {
                    //params: {foo: 'bar'}, 
                    headers: {
                      Authorization: "Bearer " + accessToken
                    }
                  }).then(response => {
                    // success callback

                    var userInfo = '';

                    //Check if the subscription is active
                    if(response.data.status == 'ACTIVE'){
                      //The subscription is active
                      
                      userInfo = {LoggedIn: true, UserId: responseData[0].UserId};
                      //Store the UserId to LocalStorage
                      localStorage.dinesafeUser = JSON.stringify(userInfo);

                      //Navigate to the Admin page
                      this.$router.push("/admin");
                    }
                    else{
                      //The subscription is inactive, or cancelled, etc.

                      //console.log("Subscription status: " + responseData.status);
                      
                      userInfo = {LoggedIn: false, UserId: responseData[0].UserId};
                      //Store the UserId to LocalStorage
                      localStorage.dinesafeUser = JSON.stringify(userInfo);

                      authenticated = false;

                      notify(
                        {
                            message: "Your subscription is inactive", 
                            type:"error", 
                            width:100, 
                            displayTime: 2000,
                            position: {
                              my: 'center center',
                              at: 'center center',
                            }
                        });

                        //callback();

                        //Navigate to a page where the user can re-activate their subscription.
                        location.href='#/renew';

                        app.$data.loadIndicatorVisible = false;
                    }
                  }, response => {
                    // error callback
                    var temp = 0;
                    //app.$data.loadIndicatorVisible = false;
                  });
                }
              )
              .catch(
                error => {
                  console.log('error', error)

                  app.$data.loadIndicatorVisible = false;
                }
              );

            //var accessToken = 'access_token$sandbox$7qgbnt8fqxyshm7q$598d7a6bc249de0c5d393c0c30754be6'; //supposed Sandbox access token   

            //return; //AJT Temp
            //--- Validate the Subscription - End

            //Navigate to the Admin page
            //this.$router.push("/admin");
          }
          else{
            //Regular user, navigate to the Contact Info page

            var userInfo = {LoggedIn: true, UserId: responseData[0].UserId};
            //Store the UserId to LocalStorage
            localStorage.dinesafeUser = JSON.stringify(userInfo);

            //Store the UserId as a global variable
            this.$store.commit("setUserId", responseData[0].UserId);

            this.$router.push("/home");
          }
        }
        else if(message == 'Incorrect password' 
            || message == 'The email you entered does not have record in our system.'){
          authenticated = false;

          notify(
          {
              message: "Incorrect e-mail or password", 
              type:"error", 
              width:100, 
              displayTime: 2000,
              position: {
                my: 'center center',
                at: 'center center',
              }
          });

          app.$data.loadIndicatorVisible = false;
        }
        else{
          authenticated = false;

          notify(
            {
                message: "Incorrect e-mail or password", 
                type:"error", //info, warming, error, success
                width:100, 
                displayTime: 2000,
                position: {
                  my: 'center center',
                  at: 'center center',
                }
            });

          app.$data.loadIndicatorVisible = false;  
        }

        //Hide the Loading Indicator
        //app.$data.loadIndicatorVisible = false;
    });   
  },
  logOut() {
    var userInfo = {LoggedIn: false};

    //Set the user to LoggedOut in LocalStorage
    localStorage.dinesafeUser = JSON.stringify(userInfo);

    localStorage.dinesafeData = '';
    localStorage.dinesafeAccountId = '';

    authenticated = false;
  },

  methods:{
    authenticated() {
      return authenticated;
    },
    /*subscriptionIsActive(){
      return subscriptionIsActive;
    }*/
  }
};

